<script>
export default {
  name: 'Features',
  data() {
    return {
      items: [1, 2, 3, 4],
    };
  },
};
</script>

<template>
  <div class="launchpad__feature-wrapper">
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="3"
        class="launchpad__feature-item"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="launchpad__feature-icon">
          <img
            :src="require(`@/assets/img/launchpad/feature-icon-${item}.png`)"
            alt=""
            class="launchpad__feature-img"
          />
        </div>
        <div class="launchpad__feature-text">
          <div class="launchpad__feature-title">{{ $t(`launchpad.features.${item}.title`) }}</div>
          <div
            class="launchpad__feature-subline"
            v-html="$t(`launchpad.features.${item}.subline`)"
          ></div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.launchpad {
  &__feature-wrapper {
    margin: 8rem 2rem;
  }

  &__feature-text {
    text-align: center;
    max-width: 50rem;
    margin: 0 auto;
  }

  &__feature-item {
    padding: 2rem;
  }

  &__feature-icon {
    width: 20rem;
    height: 20rem;
    margin: 3.5rem auto;
    border-radius: 46rem;
    background: #f8fcfd;
    box-shadow: 10px 10px 20px rgba(222, 222, 222, 0.25), 2px 2px 20px rgba(212, 202, 205, 0.2),
      -10px -10px 15px #ffffff, 10px 10px 20px rgba(181, 155, 155, 0.25), inset 2px 2px 6px #ffffff,
      inset -1px -1px 2px rgba(181, 155, 155, 0.2);
    display: flex;
    justify-content: center;
    padding: 3.5rem;

    body.binance & {
      color: $b-secondatry-font-color;
      background: $b-main-bg;
      box-shadow: $b-pools-select-shadow;
    }
  }

  &__feature-title {
    font-weight: 700;
    font-size: 2.2rem;
    margin-bottom: 1rem;

    @media screen and (max-width: $breakpoint-sm) {
      font-size: 3.2rem;
    }
  }

  &__feature-subline {
    font-weight: 500;
    font-size: 1.6rem;

    @media screen and (max-width: $breakpoint-sm) {
      font-size: 1.8rem;
    }
  }
}
</style>
